import { render } from "./RejectedOffers.vue?vue&type=template&id=540b79d5&scoped=true"
import script from "./RejectedOffers.vue?vue&type=script&lang=js"
export * from "./RejectedOffers.vue?vue&type=script&lang=js"

import "./RejectedOffers.vue?vue&type=style&index=0&id=540b79d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-540b79d5"

export default script